import React from 'react'

export const Included = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <circle fill="#00C48C" cx="7" cy="7" r="7" />
      <path
        d="M7.502 8.243c.886-1.346 1.769-2.161 2.296-2.648.25-.231.431-.398.455-.482.05-.173-.045-.309-.149-.378a.393.393 0 0 0-.415-.017c-.003.001-.267.15-.688.466-.389.292-.994.788-1.671 1.5a7.743 7.743 0 0 0-.746.913l-.001.001-.322.428-.315-.448c-.463-.566-.98-.918-1.536-1.046l-.007-.002c-.003-.001-.337-.114-.551.045 0 0-.112.087-.118.226-.006.114.06.234.194.357.582.342 1.06.814 1.384 1.367l.238.406c.145.248.429.402.74.402a.87.87 0 0 0 .684-.318l.528-.772"
        fill="#FFF"
      />
    </g>
  </svg>
)

export const NotIncluded = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g
      transform="translate(1 1)"
      stroke="#717D84"
      strokeWidth=".6"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity=".5"
    >
      <circle cx="7" cy="7" r="7" />
      <path d="M9.1 4.9 4.9 9.1M9.1 9.1 4.9 4.9" />
    </g>
  </svg>
)

export const HelpIcon = ({ color = '#A9B5BC' }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <circle fill={color} cx="7" cy="7" r="7" />
      <path
        stroke="#FFF"
        strokeWidth=".75"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.993 10.5h.014M4.9 5.6A2.1 2.1 0 1 1 7 7.7v.7"
      />
    </g>
  </svg>
)

export const PencilIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#2D2D2D" strokeWidth=".81" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <path d="m10.395 1.324 1.267 1.27c.45.453.45 1.187 0 1.64l-7.558 7.597a.581.581 0 0 1-.407.169H1V9.328c0-.153.061-.299.169-.407l7.586-7.568a1.162 1.162 0 0 1 1.64-.029zM7.104 2.977l2.907 2.911" />
    </g>
  </svg>
)

export const GaugeIcon = () => (
  <svg width="18" height="10" viewBox="0 0 18 10" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" fill="none" fillRule="evenodd">
      <path d="M15.506.694 8.22 7.63" stroke="#2D2D2D" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".81" />
      <circle fill="#2D2D2D" cx="8.331" cy="7.406" r="1" />
      <path d="M16.2 8.1A8.1 8.1 0 1 0 0 8.1" stroke="#2D2D2D" strokeWidth=".81" strokeLinecap="round" />
    </g>
  </svg>
)

export const ChevronUpIcon = props => (
  <svg {...props} width="11" height="6" viewBox="0 0 11 6" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.486 0a.739.739 0 0 0-.267.046.74.74 0 0 0-.242.163L.182 4.8c-.129.124-.19.29-.181.499a.698.698 0 0 0 .206.498c.161.155.335.22.52.197a.929.929 0 0 0 .497-.22l4.262-4.082 4.262 4.082c.13.124.303.193.52.209a.585.585 0 0 0 .521-.209.501.501 0 0 0 .206-.487.885.885 0 0 0-.23-.51L5.995.208a.74.74 0 0 0-.243-.162A.739.739 0 0 0 5.486 0z"
      fill={props.color}
      fillRule="nonzero"
    />
  </svg>
)

export const ShieldIcon = () => (
  <svg width="18" height="20" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.716 1.048 2.218 3.264A1.82 1.82 0 0 0 1 4.997v3.347c-.002 3.357 1.633 6.492 4.356 8.353L8.51 18.85c.297.2.681.2.978 0l3.155-2.153c2.723-1.861 4.358-4.996 4.356-8.353V4.997a1.82 1.82 0 0 0-1.218-1.733L9.284 1.048a.868.868 0 0 0-.568 0z"
      stroke="#000"
      strokeWidth=".9"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const MotorcycleIcon = () => (
  <svg width="19" height="22" viewBox="0 0 19 22" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#000" strokeWidth=".7" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <path d="m5.936 3.903-1.62.968-.648 2.903.972.645s-1.296 5.162 3.24 8.71L5.936 3.903zM13.064 3.903l1.62.968.648 2.903-.972.645s1.296 5.162-3.24 8.71l1.944-13.226zM9.5 21h0c-.895 0-1.62-.722-1.62-1.613v-5.484c0-.89.725-1.613 1.62-1.613.895 0 1.62.723 1.62 1.613v5.484c0 .89-.725 1.613-1.62 1.613zM3.992 6.161l-1.62.645 1.62-.645zM15.008 6.161l1.62.645-1.62-.645zM9.5 1c-.915 0-3.564.323-3.564 1.613S7.88 5.839 7.88 5.839h3.24s1.944-1.936 1.944-3.226S10.415 1 9.5 1zM5.936 3.903l-1.944-1.29 1.944 1.29zM3.992 2.613H1.908a.325.325 0 0 1-.278-.157l-.583-.967A.323.323 0 0 1 1.324 1h2.344c.179 0 .324.145.324.323v1.29zM13.064 3.903l1.944-1.29-1.944 1.29zM15.008 2.613h2.084c.114 0 .22-.06.278-.157l.583-.967A.323.323 0 0 0 17.676 1h-2.344a.323.323 0 0 0-.324.323v1.29z" />
    </g>
  </svg>
)

export const MotorcycleTrack = () => (
  <svg width="67" height="67" viewBox="0 0 67 67" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter x="-45.4%" y="-32.4%" width="190.8%" height="190.8%" filterUnits="objectBoundingBox" id="frf7enlira">
        <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" in="shadowBlurOuter1" result="shadowMatrixOuter1" />
        <feOffset in="SourceAlpha" result="shadowOffsetOuter2" />
        <feGaussianBlur stdDeviation=".5" in="shadowOffsetOuter2" result="shadowBlurOuter2" />
        <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" in="shadowBlurOuter2" result="shadowMatrixOuter2" />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="shadowMatrixOuter2" />
        </feMerge>
      </filter>
      <path
        d="m21.092 7.092.192.01c8.232.395 14.817 6.98 15.213 15.212l.01.192c.354 7.377-5.34 13.645-12.716 14-.428.02-.857.02-1.285 0L7.8 35.8l-.707-14.707c-.355-7.377 5.338-13.645 12.715-14 .428-.02.857-.02 1.285 0z"
        id="d619jb70wb"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero" transform="rotate(-45 36.799 15.707)">
        <use fill="#000" filter="url(#frf7enlira)" xlinkHref="#d619jb70wb" />
        <path
          stroke="#5D00FF"
          strokeWidth=".5"
          d="m20.66 7.328.42.014c4.137.199 7.824 1.91 10.529 4.583a15.628 15.628 0 0 1 4.638 10.401c.178 3.705-1.12 7.092-3.367 9.6a13.004 13.004 0 0 1-9.101 4.33c-.42.02-.841.02-1.26 0L8.037 35.56l-.696-14.48a13.082 13.082 0 0 1 3.393-9.454A13.082 13.082 0 0 1 21.08 7.342z"
          fill="#FFF"
          fillRule="evenodd"
        />
      </g>
      <path
        d="M21.54 32.7a1.76 1.76 0 0 1 3.465-.44h-1.213a.659.659 0 0 0-1.152.44.66.66 0 0 0 1.152.44h1.213a1.761 1.761 0 0 1-3.465-.44m15.4 0c0-.539.242-1.022.624-1.344l.565 1.012a.66.66 0 1 0 .683-.318l-.578-1.047A1.759 1.759 0 0 1 40.46 32.7a1.76 1.76 0 1 1-3.52 0M20 32.7a3.3 3.3 0 0 0 6.571.44h.577c-.02.426-.072.806-.101 1.093h5.974c.983 0 1.279-.742 1.265-1.313v-1.107c.213 0 .31-.103.358-.265.272-.81.477-1.687.681-2.496-.097-.064-.22-.16-.372-.25.069-.165.248-.688.44-1.234.21.311.803 1.352 1.41 2.43a3.3 3.3 0 1 0 .678-.366 272.426 272.426 0 0 1-1.202-2.2c.145-.287.166-.363.262-.529.184.159.38.297.509.297.304 0 .33-.345.33-.77 0-.425-.026-.77-.33-.77-.16 0-.426.214-.642.417-.08-.065-.336-.13-.402-.196-.272-.135-.272-.405-.34-.54-.137-.404-.545-.337-.682-.337-.204 0-.68 0-.907.003-.427.01-1.314.014-1.314.357 0 .12 1.063.076 1.53.076.136.27.447.612.447.908 0 .33-.193.611-.454.611-.389-.428-.774-.639-1.182-.639-1.499 0-2.531.716-4.098 2.2H26.54c-.372 0-.84-1.093-1.342-1.093H22.42v.406c.284.173.44.274.645.41-.741.222-1.278.38-2.043.606-.163.139-.252.214-.369.31.234.09.591.241.591.241.53-.344 1.114-.46 1.678-.46.447 0 1.292-.007 2.275.412 1.403.683 1.84 1.838 1.936 2.908h-.562A3.301 3.301 0 0 0 20 32.7"
        fill="#5D00FF"
      />
    </g>
  </svg>
)

export const CalendarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <g
      transform="translate(1 1)"
      stroke="#2D2D2D"
      strokeWidth=".81"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect y="1.62" width="16.2" height="14.58" rx="1.62" />
      <path d="M4.05 0v3.24M12.15 0v3.24" />
    </g>
  </svg>
)

export const WalletIcon = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 1)" stroke="#000" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3.889h4v6.222h-4c-1.767 0-3.2-1.393-3.2-3.111h0c0-1.718 1.433-3.111 3.2-3.111z" strokeWidth=".729" />
      <rect strokeWidth=".729" width="16" height="14" rx="1.62" />
      <path strokeWidth="1.62" d="M12 7h.08" />
    </g>
  </svg>
)
